
import Card from "./Card"
import { mapActions } from "vuex"

export default {

  name: "CardForm",

  components: { Card },

  directives: {

    "number-only": {
      bind(el){
        el.addEventListener("keypress",(e)=>{
          if(e.charCode < 48 || e.charCode > 57) e.preventDefault()
        })
      }
    },

    "letter-only":{
      bind(el){
        el.addEventListener("keypress",(e)=>{
          if(e.charCode >= 48 && e.charCode <= 57) e.preventDefault()
        })
      }
    }

  },

  props: {

    formData:{
      type:Object,
      default:()=>({
        cardName:"",
        cardNumber:"",
        cardMonth:"",
        cardYear:"",
        cardCvv:"",
        cardVezes:1
      })
    },

    valor:{
      type:[Number,String],
      default:0
    },

    plano:String,
    id_plan:String,

    vezesByPlan:{
      type:Number,
      default:1
    },

    isSale:{
      type:Boolean,
      default:false
    },

    appsRenovacao:{
      type:Array,
      default:()=>[]
    },

    backgroundImage:[String,Object],
    randomBackgrounds:{
      type:Boolean,
      default:true
    }

  },

  data(){

    return{

      fields:{
        cardNumber:"v-card-number",
        cardName:"v-card-name",
        cardMonth:"v-card-month",
        cardYear:"v-card-year",
        cardCvv:"v-card-cvv"
      },

      minCardYear:new Date().getFullYear(),

      cardNumberMaxLength:19,

      isCardNumberMasked:true

    }

  },

  mounted(){

    if(!this.formData.cardVezes){
      this.formData.cardVezes = this.vezesByPlan
    }

  },

  methods:{

    ...mapActions(["setLoading"]),

    formatValor(v){
      return Number(v).toLocaleString("pt-BR",{minimumFractionDigits:2})
    },

    generateMonthValue(n){
      return n < 10 ? `0${n}` : n
    },

    valorParcela(n){

      const total = Number(this.valor || 0)

      if(!n || !total) return "0,00"

      const parcela = total / n

      return parcela.toLocaleString("pt-BR",{
        minimumFractionDigits:2,
        maximumFractionDigits:2
      })

    },

    generateVezes(n){

      return `${n}x R$ ${this.valorParcela(n)}`

    },

    changeName(e){
      this.formData.cardName = e.target.value
      this.$emit("input-card-name",this.formData.cardName)
    },

    changeNumber(e){

      let value = e.target.value.replace(/\D/g,"")

      this.formData.cardNumber = value
        .replace(/(\d{4})/g,"$1 ")
        .trim()

      this.$emit("input-card-number",this.formData.cardNumber)

    },

    changeMonth(){
      this.$emit("input-card-month",this.formData.cardMonth)
    },

    changeYear(){
      this.$emit("input-card-year",this.formData.cardYear)
    },

    changeCvv(e){
      this.formData.cardCvv = e.target.value
      this.$emit("input-card-cvv",this.formData.cardCvv)
    },

    async postCard(){

      if(!this.formData.cardName){
        this.$toast.warning("Preencha o nome do titular")
        return
      }

      if(!this.formData.cardNumber){
        this.$toast.warning("Preencha o número do cartão")
        return
      }

      if(!this.formData.cardMonth){
        this.$toast.warning("Preencha o mês")
        return
      }

      if(!this.formData.cardYear){
        this.$toast.warning("Preencha o ano")
        return
      }

      if(!this.formData.cardCvv){
        this.$toast.warning("Preencha o CVV")
        return
      }

      const dadosCartao = {

        numero:this.formData.cardNumber.replace(/ /g,""),

        numero_mascara:this.formData.cardNumber,

        nome:this.formData.cardName,

        mes:this.formData.cardMonth,

        ano:this.formData.cardYear,

        cvv:this.formData.cardCvv,

        vezes:this.formData.cardVezes,

        valor:this.valor,

        id_plan:this.id_plan,

        apps_renovacao:this.appsRenovacao,

        is_sale:this.isSale

      }

      try{

        this.setLoading(true)
        
        const response = await this.$http.post("/empresa/cartao", dadosCartao)

        this.$toast.success("Pagamento realizado com sucesso!")

        this.$emit("card-success", {
          dadosCartao,
          response: true
        })

      }
      catch(e){

        this.$toast.warning("Erro ao processar pagamento")

      }
      finally{

        this.setLoading(false)

      }

    }

  }

}
